import { Component } from '@angular/core';
import { NavigationService } from '@shared/services/navigation.service';

@Component({
  selector: 'app-back-btn',
  templateUrl: './back-btn.component.html',
  styleUrls: ['./back-btn.component.scss']
})
export class BackBtnComponent {

  constructor(
    // private backbtnserviceService: BackbtnserviceService,
    private navigation: NavigationService ) { }

  back(event){
    event && event.preventDefault();
    this.navigation.back();
  }

}
